import React, { Component, Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authActions, alertActions } from '../../store/actions';
import { history } from '../../helpers/history';
import Footer from '../../components/Footer/footer';
import { validationEmail } from '../../helpers/response';
import { CounsellorDesiredRole } from '../../config';
import { constants } from '../../Constants';
import { WhitelabelActions } from '../../store/actions';
import defaultImage from '../../static/images/default_BG.png';
import '../../static/css/styles.css';
import '../../static/style/main.css';
import { counsellorLogin } from '../../helpers/ConstantID';
import saayaLogo from '../../static/images/saaya_logo.png'
import { UnAuthenticatedHeader } from '../../components/HeaderUnAunthicated';

const Image = lazy(() => import('../../components/Image/index'));

class CounsellorLogIn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_address: '',
			password: '',
			submitted: false,
			desiredRole: CounsellorDesiredRole,
			is_mobile: false,
			error_email: false,
			error_pwd: false
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillMount() {
		this.props.fetchWhitelabel();
		const user = JSON.parse(localStorage.getItem('user'));
		if (user === null) {
		} else {
			if (user.role === 0) {
				history.replace('/home/counsellor');
			}
			if (user.role === 1) {
				history.replace('/home');
			}
		}
	}

	componentDidMount() {
		// clear alert on location change
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
		this.props.clearAlertActions();
		document.addEventListener("keydown", this.onPressEnter);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onPressEnter);
	}

	patientSignin = () => {
		history.push('/');
	};

	forgotPassword = () => {
		history.push('/emailverification');
	};
	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}
	handleSubmit(ev) {
		ev.preventDefault();
		this.setState({ submitted: true });
		const { email_address, password, desiredRole } = this.state;
		const { whitelabel } = this.props;
		const projectName = whitelabel[0].name;

		if (email_address && password) {
			if (!validationEmail(email_address)) {
				this.setState({ error_email: true, error_pwd: false });
				const message = constants.EMAIL_VALIDATION_MSG;
				this.props.alertError(message);
			} else {
				this.setState({ error_email: false, error_pwd: false });
				this.props.loginAuthentication(email_address, password, desiredRole, projectName, this.props.location.state);
			}
		} else {
			this.setState({ error_email: true, error_pwd: true });
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		}

	}

	onPressEnter = (ev) => {
		if (ev.keyCode == 13 && ev.key === "Enter") {
			this.handleSubmit(ev)
		}
	}

	render() {
		const { alert, whitelabel } = this.props;
		const showError = alert.message && alert.message.length > 0;
		const { error_email, error_pwd, email_address, password } = this.state;

		return (
			<React.Fragment>
				<UnAuthenticatedHeader/>
				<div className="sh-layout">
					<div className="sh-counsellor-login-comp">
						<div className="sh-gnrl-inner">
							<div className="sh-gnrl-logo">
								<img src={whitelabel ? whitelabel[0].logo_url : defaultImage} alt="logo" id={counsellorLogin.sh_cl_logo} />
							</div>
							<div className="sh-clc-heading">
								<h2 className="sh-clc-h2" id={counsellorLogin.sh_cl_text1}>
									{constants.COUNSELLOR_LOGIN}
								</h2>
								<p className="sh-clc-gnrl-text sh-mb-20" id={counsellorLogin.sh_cl_text2}>
									{constants.SIGN_IN_SESSION}
								</p>
							</div>
							<div className="sh-clc-form">
								<div className="sh-gnrl-row sh-mb-15">
									<div className="sh-input-group">
										<input
											autoComplete="off"
											id={counsellorLogin.sh_cl_email}
											value={email_address || ""}
											required
											type="email"
											name="email_address"
											onChange={this.handleChange}
											className={`sh-input-text ${error_email ? 'sh-input-error' : ''}
					  ${email_address && "sh-input-active"}`}
										/>
										<label htmlFor={counsellorLogin.sh_cl_email} className="sh-input-label">
											{constants.EMAIL_ADDRESS}
										</label>
									</div>
								</div>

								<div className="sh-gnrl-row sh-mb-5">
									<div className="sh-input-group">
										<input autocomplete="off" id={counsellorLogin.sh_cl_pass} required type="password"
											onChange={this.handleChange} value={password}
											name='password' className={`${error_pwd ? 'sh-input-error' : ''} sh-input-text`} />
										<label htmlFor={counsellorLogin.sh_cl_pass} className="sh-input-label">
											{constants.ENTER_PASSWORD}
										</label>
									</div>
								</div>

								<div className="sh-grnl-row sh-mb-5">
									<span className="sh-gnrl-error-msg">{alert.message}</span>
								</div>

								<div className="sh-gnrl-row sh-dflex sh-mb-30">
									<div className="sh-clc-remember">
									</div>
									<div className="sh-clc-forgot-pass">
										<button id={counsellorLogin.sh_cl_forgot_pass} onClick={this.forgotPassword}>
											{constants.FORGOT_PASSWORD}</button>
									</div>
								</div>

								<div className="sh-gnrl-row sh-mb-15">
									<button id={counsellorLogin.sh_cl_sign_in_btn} onClick={this.handleSubmit}
										className="sh-gnrl-btn sh-login-btn">
										{constants.SIGN_IN}
									</button>
								</div>
								<div className="sh-gnrl-row sh-mb-15 blog-faq-block">
									<label className="sh-plc-cnslr">
										{constants.FAQ_TEXT}
										<a href='/faq'><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
									</label>
								</div>
								<div className="sh-gnrl-row sh-mb-15 blog-faq-block">
									<label className="sh-plc-cnslr">
										{constants.VIEW_BLOGS}
										<a target={"_blank"} href='https://saayahealth.com/blog'><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
									</label>
								</div>
							</div>
						</div>
					</div>
					<Footer />
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { authstate } = state.auth;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		authstate,
		whitelabel,
	};
}
function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		getOnBoardingStatus: (onboardingLoginEmail) => {
			dispatch(authActions.getOnBoardingStatus(onboardingLoginEmail));
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		loginAuthentication: (email_address, password, desiredRole, projectName, locationHistory) => {
			dispatch(authActions.login(email_address, password, desiredRole, projectName, locationHistory));
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CounsellorLogIn));



// WEBPACK FOOTER //
// ./src/screens/CounsellorLogIn/index.js